import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "./Navigation.css";
import MobileNav from "./MobileNav";
import { Link } from 'react-router-dom';
import "../App.css"


const Navigation = () => {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);

    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location]);

    const handleNavClick = (path) => {
        setActiveLink(path);
    };

    return (
        <>
            <div className='fullnav'>
                <div className="navleft">
                    <div className="leftnavimgdiv">
                        <img className="navleftimg" src="/assets/Grid.png" alt="Logo" />
                    </div>
                </div>

                <div className="navright">
                    <li
                        className={`navitems ${activeLink === '/home' ? 'active' : ''}`}
                        onClick={() => handleNavClick('/home')}
                    >
                        <a href="/home">Home</a>
                    </li>

                    <li
                        className={`navitems ${activeLink === '/pl' ? 'active' : ''}`}
                        onClick={() => handleNavClick('/pl')}
                    >
                        <a href="/pl">Prime Location</a>
                    </li>

                    <li
                        className={`navitems ${activeLink === '/bs' ? 'active' : ''}`}
                        onClick={() => handleNavClick('/bs')}
                    >
                        <a href="/bs">Best Sellers</a>
                    </li>


                   <li
                        className={`navitems ${activeLink === '/inv' ? 'active' : ''}`}
                        onClick={() => handleNavClick('/inv')}
                    >
                        <a href="/inv">Investment</a>
                    </li>

                    

                    <li
                        className={`navitems ${activeLink === '/comm' ? 'active' : ''}`}
                        onClick={() => handleNavClick('/com')}
                    >
                        <a href="/com">Commercials</a>
                    </li>
                </div>

                <div className='contactdiv'>
                    {/* <button className="package" href="/contact">Contact Us</button> */}
                    <Link to="/contact" className="package">Contact Us</Link>
                </div>
            </div>

    
  <div className="mobnavmain">
    <MobileNav/>
</div>  
        
        </>
    );
};

export default Navigation;
